<mat-card-title align="center">
    <i class="material-icons iconTitle">
        people_alt
    </i>
    Autores
</mat-card-title>

<mat-divider align="center"></mat-divider>

<mat-dialog-content class="mat-typography" style="margin-top: 10px; width: 240px; height: 280px;" align="center">

    <span>
        <a href="https://github.com/franklinarauj" style="font-size: 22px; color: white; margin-top: 5px;">
            Franklin Araújo
        </a>
    </span>
    <br><br>
    com auxílio de:
    <br><br>
    <span>
        <a href="https://www.linkedin.com/in/alexandre-morais-borges-a36556199/" style="font-size: 20px; color: white; margin-top: 5px;">
            Alexandre Morais
        </a>
    </span>

    <br><br>
    <span>
        <a href="https://www.linkedin.com/in/arthurpcorrea/" style="font-size: 20px; color: white; margin-top: 5px;">
            Arthur Passos
        </a>
    </span>

    <br><br>
    <span>
        <a href="https://www.linkedin.com/in/matheus-eduardo-muniz-6b322719a/" style="font-size: 20px; color: white; margin-top: 5px;">
            Matheus Muniz
        </a>
    </span>

    <br><br>
    <span>
        <a href="https://www.linkedin.com/in/murilo-kronbauer-293937184/" style="font-size: 20px; color: white; margin-top: 5px;">
            Murilo Kronbauer
        </a>
    </span>

    <br><br>
    <span>
        <a href="https://www.linkedin.com/in/rafael-guido-de-jesus-toccolini-47ab673a/" style="font-size: 20px; color: white; margin-top: 5px;">
            Rafael Guido
        </a>
    </span>

</mat-dialog-content>

<mat-dialog-actions align="center">
    <button mat-button mat-dialog-close>Fechar</button>
</mat-dialog-actions>